import React, { useEffect } from 'react';

import { PdpPageEvents, SelectionValidatedV0 } from '@vp/pdp-events';

import { ToastProvider } from '../components/StickyToast';

export const useSelectionValidated: ToastProvider = (setToast, unsetToast) => {
  useEffect(() => {
    const handleSelectionValidated = (event: SelectionValidatedV0) => {
      const toastId = `selectionValidated-${event.reason}`;

      if (event.result === 'invalid') {
        setToast({
          skin: 'error',
          body: <>{event.reasonMessage}</>,
          id: toastId,
        });
      } else if (event.result === 'valid') {
        unsetToast(toastId);
      }
    };

    return PdpPageEvents.listenToSelectionValidatedEventV0(handleSelectionValidated);
  }, []);
};
